import { apiGet, apiPost } from '@api/api.utils'
import { IResponseCommon } from '@api/common.types'
import { IResponseAddressNotConfirmedList } from './api.types'


const route = '/addressNotConfirmed'

/** Основной список неподтверждённых адресов. */
export const getAddressNotConfirmedList = (pageNumber: number, search?: string, signal?: AbortSignal): Promise<IResponseAddressNotConfirmedList> =>
    apiGet<IResponseAddressNotConfirmedList>(`${route}/getAddressNotConfirmedList`, { params: { pageNumber, search }, signal })

/** Отправка выбранной записи в Telegram канал адресов. */
export const sendAddressNotConfirmedToTelegram = (printID: number): Promise<IResponseCommon> =>
    apiPost<IResponseCommon>(`${route}/sendAddressNotConfirmedToTelegram`, { params: { printID } })